import { useQuery } from "@tanstack/react-query";
import { productsApi } from "@/api/products";

export function useProducts() {
  return useQuery({
    queryKey: ["products"],
    queryFn: productsApi.getProducts,
  });
}

export function useProduct(id: number | undefined) {
  return useQuery({
    queryKey: ["products", id],
    queryFn: () => productsApi.getProduct(id!),
    enabled: !!id,
  });
}
